(async () => {
	const userIdCName = "sh_UId";
	const bhTokenCName = "bh_Tk";
	const pagePath = "/pages/rewards/"; // Page where it needs to execute.
	const bhIframeUrl = `https://app.bubblehouse.com/blocks/v2023061/${bhAccountName}/Rewards7?instance=bubblehouse-rewards`;
	const bhScriptUrl = `https://app.bubblehouse.com/s/${bhAccountName}/bubblehouse.js`;

	if (window.location.pathname !== pagePath) return;

	const getCookie = (n) =>
		document.cookie
			.split("; ")
			.find((row) => row.startsWith(`${n}=`))
			?.split("=")[1];

	const setCookie = (n, v, e) => {
		const expiryDate = new Date();
		expiryDate.setTime(expiryDate.getTime() + e * 1000);
		document.cookie = `${encodeURIComponent(n)}=${encodeURIComponent(
			v
		)}; path=/; Secure; SameSite=Strict; expires=${expiryDate.toUTCString()}`;
	};

	const addIframe = (token) => {
		const content = document.querySelector("main .content");
		const loadingEl = document.getElementById("loading-state");
		loadingEl.classList.remove("hidden");
		// add bubblehouse scripts
		const script = document.createElement("script");
		script.src = bhScriptUrl;

		// create Iframe
		const iframe = document.createElement("iframe");
		iframe.setAttribute("id", "bubblehouse-rewards");
		iframe.setAttribute(
			"sandbox",
			"allow-top-navigation allow-scripts allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin"
		);
		iframe.setAttribute("allow", "clipboard-write");
		iframe.setAttribute("style", "border: 0; width: 100%; height: 1500px;");
		iframe.setAttribute("loading", "lazy");

		iframe.setAttribute("src", token ? `${bhIframeUrl}&auth=${token}` : bhIframeUrl);
		iframe.addEventListener("load", () => loadingEl.classList.add("hidden"));
		iframe.classList.add("full-row");

		// hide breadcrumbs
		const breadcrumbs = document.querySelector(".breadcrumbs");
		breadcrumbs.classList.add("hidden");
		content.classList.add("mt-0"); // removes default page margin top

		content.appendChild(iframe);
		content.appendChild(script);
	};

	// Check if user is logged in, create BH Token if needed
	const userId = getCookie(userIdCName);
	let bhToken = getCookie(bhTokenCName);

	if (!userId) {
		// session expired remove bubble token
		setCookie(bhTokenCName, "", -1);
		bhToken = false;
	}

	if (!bhToken && userId) {
		// session active request bubble token
		const response = await fetch(`${apiUrl}/marketing`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				endpoint: "bubble-house-auth",
				site: siteId,
				params: {
					userId,
				},
			}),
		});

		if (response.status === 200) {
			const { token } = await response.json();

			setCookie(bhTokenCName, token, 3600);
			bhToken = token;
		}
	}

	// Listen to BH Iframe messages
	window.addEventListener("message", (e) => {
		// add to cart
		if (e.data.bubblehouseBlockClientCall && e.data.bubblehouseBlockClientCall === "AddProductToCart1") {
			const { variantId, quantity } = e.data;
			if (!variantId) return;

			const payload = {
				site: window.arena.siteId,
				...(window.cart?.cartId && { cartId: window.cart.cartId }),
				items: [
					{
						merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
						quantity: quantity || 1,
					},
				],
			};

			window.arena.addItemsCart(payload);
		}
	});

	// It will render the iframe in both case authenticated or unauthenticated
	addIframe(bhToken);
})();
